import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';

export type RenderHtmlProps = {
    data: string;
    className?: string;
}

/* eslint-disable react/no-danger */
export const RenderHtml = ({ data, className }: RenderHtmlProps) => {
    if (data.substring(0, 1) === '@') {
        return (
            <div className={className}>
                <I18n messageId={data.replace('@', '')}/>
            </div>
        );
    }
    return (
        <div
            dangerouslySetInnerHTML={{
                __html: data,
            }}
            className={className}
        />
    );
};
